import { Box, CircularProgress } from "@mui/material";

export default function Loading() {
  return (
    <Box sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress size={120} />
    </Box>
  )
}
